import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionPlanService {

  constructor(
    private httpService: HttpService
  ) { }

  postSubscriptionPlanGetApi(typePassed, tokenPassed, slugPassed){
    const  url = `billingservice/subscription/detail/all`
    const obj = { 
      type:typePassed,
      token: tokenPassed,
      slug: slugPassed
    }
    return this.httpService.postbillData(url, obj);
  }
  getSubscriptionPlanGetApiForSpecific( idPassed){
    const  url = `billingservice/subscription/detail/${idPassed}`
    return this.httpService.getDatabill(url);
  }
  getSubscriptionDetail(){
    const url = `billingservice/subscription/detail/my-app`;
    return this.httpService.getbillData(url);
  }
}
